// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetBannerEnrichmentsRequest,
  TGetBannerEnrichmentsModel,
  IMappers,
  TGetBannerEnrichmentsResponse,
  IGetBannerEnrichmentsResponse,
  IGetBannerEnrichmentsResponseError,
} from './types';

export const defaultConfig: TGetBannerEnrichmentsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'ad-banner',
  pathApi: '/v1/get-banner-enrichments/',
  requestType: 'json',
} as TGetBannerEnrichmentsModel;

export function createGetBannerEnrichmentsModel(parameters: IGetBannerEnrichmentsRequest): TGetBannerEnrichmentsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetBannerEnrichmentsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetBannerEnrichmentsRequest;
}

export async function fetchGetBannerEnrichments<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBannerEnrichmentsOptions<TResponse200, TResponse400>): Promise<
  TGetBannerEnrichmentsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetBannerEnrichmentsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBannerEnrichmentsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetBannerEnrichmentsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetBannerEnrichmentsResponse;
}
